'use client'
import type { View } from 'product-list/types/View'
import { dataTestIds } from 'product-list/utils/testIds'
import { useCallback } from 'react'
import { cx } from 'utils/cx'
import styles from './ViewIcon.module.css'

interface ViewIconProps {
	readonly view: View
	readonly icon: React.ReactNode
	readonly label: string
	readonly isSelected: boolean
	readonly dataTestId?: string
	readonly onClickView: (view: View) => void
}

export function ViewIcon({
	view,
	icon,
	label,
	isSelected,
	dataTestId,
	onClickView,
}: ViewIconProps) {
	const handleClickView = useCallback(
		() => onClickView(view),
		[onClickView, view]
	)

	return (
		<label
			className={cx(styles.viewItem, !isSelected && styles.unselected)}
			title={label}
			data-testid={
				isSelected
					? dataTestIds.productListViewSelected
					: dataTestIds.productListViewUnselected
			}
		>
			<input
				id={`view-${view}`}
				data-testid={dataTestId}
				type='radio'
				name='product-list-view'
				onClick={handleClickView}
			/>
			<div className={cx(styles.iconWrapper, isSelected && styles.selected)}>
				{icon}
			</div>
		</label>
	)
}
